import SMEService from '@/services/SMEService';

export const servicosSME = {
    namespaced: true,
    actions: {
        buscarRedeEnsino ({ dispatch }, { agrupamento }) {
            return SMEService.buscarRedeEnsino({ agrupamento })
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },

        buscarFilaCreche ({ dispatch }, { intervalo }) {
            return SMEService.buscarFilaCreche({ intervalo })
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },

        buscarFilaCrecheRegionalMensal ({ dispatch }, { intervalo }) {
            return SMEService.buscarFilaCrecheRegionalMensal({ intervalo })
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        

        buscarMatriculas ({ dispatch }, { intervalo, agrupamento }) {
            return SMEService.buscarMatriculas({ intervalo, agrupamento })
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarTMACreche ({ dispatch }, { intervalo, regionalidade }) {
            return SMEService.buscarTMACreche({ intervalo, regionalidade })
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarTMACrecheDiario ({ dispatch }, { inicio, fim, regionalidade }) {
            return SMEService.buscarTMACrecheDiario({ inicio, fim, regionalidade })
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarTMACrecheMensal ({ dispatch }, { inicio, fim, regionalidade }) {
            return SMEService.buscarTMACrecheMensal({ inicio, fim, regionalidade })
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarTMACrecheAnual ({ dispatch }, { inicio, fim, regionalidade }) {
            return SMEService.buscarTMACrecheAnual({ inicio, fim, regionalidade })
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        
        buscarINSEDetalhado () {
            return SMEService.buscarINSEDetalhado()
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },

        buscarINSEConsolidado ({ dispatch }, { agrupamento }) {
            return SMEService.buscarINSEConsolidado({ agrupamento })
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },

    },
    state: {},
    mutations: {},
};
